<template>
  <div class="c-embed">
    <iframe :src="url" />
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'OEmbed',
  props: {
    url: String
  }
}
</script>

<style lang="scss">
.c-embed {
  flex: 1 1 0;
  position: relative;

  iframe {
    border: 0;
    height: 100%;
    left: 0;
    margin: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
